import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import injectSheet from 'react-jss';
import { Layout, Typography } from 'antd';
import routes from '../../routes';
import { classesPropType } from '../prop-types';
import LogoutLink from '../Common/LogoutLink';

const { Content, Footer } = Layout;
const { Text } = Typography;

const styles = {
  layout: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: '25px 33px 0 33px',
    width: '100%',
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  center: {
    textAlign: 'center',
  },
  link: {
    margin: '5px',
  },
};

function CustomLayout({ children, classes }) {
  return (
    <Layout className={classes.layout}>
      <Content className={classes.content}>
        {children}
      </Content>
      <Footer className={classes.footer}>
        <Text>Cupcake</Text>
        <div className={classes.center}>
          <Link to={routes.termsOfService} className={classes.link}>
            Terms of Service
          </Link>
          <Link to={routes.privacyPolicy} className={classes.link}>
            Privacy Policy
          </Link>
          <LogoutLink />
        </div>
      </Footer>
    </Layout>
  );
}

CustomLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  classes: classesPropType.isRequired,
};

export default injectSheet(styles)(CustomLayout);
